module.exports = __webpack_public_path__ + "static/img/honor6.666e13a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor6.jpg
// module id = 21yr
// module chunks = 4